export function camelToSnakeCase<T>(value: unknown): T {
  if (Array.isArray(value)) {
    return value.map((item) => camelToSnakeCase(item)) as T;
  }

  if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
    return Object.entries(value as Record<string, unknown>).reduce(
      (acc, [key, val]) => {
        const snakeKey = key.replace(
          /([a-z0-9])([A-Z])/g,
          (_match, prev: string, letter: string) => `${prev}_${letter.toLowerCase()}`,
        );
        acc[snakeKey] = camelToSnakeCase(val);
        return acc;
      },
      {} as Record<string, unknown>,
    ) as T;
  }

  return value as T;
}
